<template>
    <main-content>
        <div class="bg-white p-4 rounded shadow-sm">
            <div class="mt-2 mb-5 h5">تنظیمات تسویه</div>
            <form @submit.prevent="submit" id="wallet_settings">
                <div class="row">
                    <div
                         class="col-12 col-md-6 my-2"
                    >
                        <label for="wallet_hashid">شناسه کیف پول</label>
                        <input type="text"
                               name="wallet_hashid"
                               id="wallet_hashid"
                               class="form-control"
                               dir="ltr"
                               v-model="form_data.wallet_hashid"
                        >
                    </div>
                    <div class="col-12 mt-5">
                        <button type="submit"
                                id="submit-btn"
                                class="btn btn-success"
                        >
                            ذخیره تغییرات
                        </button>
                    </div>
                </div>
            </form>
        </div>
    </main-content>
</template>

<script>
    import mainContent from '@/components/main-content'
    import {ivrService} from "@/common/api.service";
    import $ from "jquery";
    import {KTApp} from "@/plugins/core/app";

    export default {
        components: {
            mainContent,
        },
        data() {
            return {
                form_data: {
                    wallet_hashid: '',
                },
            };
        },
        mounted() {
            ivrService.find(this.$route.params.hashid).then(res => {
                let data = res.data.data;
                this.form_data.wallet_hashid = data.wallet_hashid;
            });
        },
        methods: {
            submit() {
                let form = $('#wallet_settings');
                let btn = $('#submit-btn');

                form.validate({
                    rules: {
                        wallet_hashid: {
                            required: true,
                        },
                    },
                });

                if (!form.valid()) {
                    return;
                }

                let params = {
                    wallet_hashid: this.form_data.wallet_hashid,
                };

                KTApp.progress(btn);

                ivrService.updateWallet(this.$route.params.hashid, params).then(res => {
                    this.$router.push('/gateways');
                }).catch(({response}) => {
                    if (response.data) {
                        form.validate().showErrors(response.data.data);
                    }

                    this.showMsg(form, 'danger', response.data.message);
                }).finally(() => {
                    KTApp.unprogress(btn)
                });
            },
        },
    }
</script>
